import { compose, mdsWidget } from 'dojo/_base/declare';
import dojoDeclareTyped from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import Calendar from 'dojox/calendar/Calendar';
import MonthColumnView from 'dojox/calendar/MonthColumnView';
import MatrixView from 'dojox/calendar/MatrixView';
import ColumnView from 'dojox/calendar/ColumnView';
import Mouse from 'dojox/calendar/Mouse';
import Keyboard from 'dojox/calendar/Keyboard';
import Touch from 'dojox/calendar/Touch';
import domStyle from 'dojo/dom-style';
import aspect from 'dojo/aspect';
import MoreLabelRenderer from '../Renderers/moreCoreLabelRenderer';
import MoreVerticalRenderer from '../Renderers/moreCoreVerticalRenderer';
import MoreHorizontalRenderer from '../Renderers/moreCoreHorizontalRenderer';
import query from 'dojo/query';
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import methodHooks from 'more/mdsMethodHooks';
// NOTE (JS2TS): ported from the Group-A moreCalendarMixin.js; the ambient `declare module` for this path was
// removed from modules.d.ts (this real module now supplies the type). `declare` is used two ways: the class-level
// @declare(...) is the DeclareDecorator, while the inline dojo/_base/declare([bases])(props) calls use a separate
// raw-declare alias (dojoDeclare). Dropped dead deps (dojo/has, dojo/date/stamp, dom-geometry, dojo/date,
// dojo/date/locale, dojox ColumnViewSecondarySheet, dojo/topic, dojo/dom-attr, unused dojox VerticalRenderer).
const dojoDeclare: any = dojoDeclareTyped;

class moreCalendarMixin extends methodHooks(compose(Calendar)) {
    [key: string]: any;

    // summary:
    //		A Calendar Mixin to instantiate the classes with declare in Javascript that embeds a month column view.
    //      an abstraction layer between Dojo and TS


    _createDefaultViews(): any {
        super._createDefaultViews.apply(this, arguments as any);

        // check for touch-device
        var deviceBaseClasses: any = [];
        if ("ontouchstart" in document.documentElement) {

            console.log("You're using a touch device");
            deviceBaseClasses = [Touch];

        }
        else {
            console.log("You're using mouse and keyboard");
            deviceBaseClasses = [Keyboard, Mouse];
        }

        this.columnView = dojoDeclare([ColumnView].concat(deviceBaseClasses))(
            lang.mixin(
                this.columnView.params, {
                verticalRenderer: MoreVerticalRenderer,
                horizontalRenderer: MoreHorizontalRenderer,
                //rowHeaderGridSlotDuration: 15,
                rowHeaderLabelSlotDuration: 30,
                rowHeaderLabelOffset: -7,
                hourSize: 70,
                _setText: function (node: any, text: any, allowHTML: any) {
                    // SetText überschreiben. in ViewBase.js wird da irgendein Mist gemacht den kein Mensch braucht
                    if (text != null) {
                        node.innerHTML = text;
                    }
                },
                subColumnLabelFunc: function (v: any) {
                    return v;
                },
                //,subColumnAttr: "subColumn" // geht nicht?? muss "calendar" heissen
                // verhindern, dass durch das setzen von "subColumns" das layout neu gerendert wird
                invalidatingProperties: ["columnCount", "startDate", "minHours", "maxHours", "hourSize", "verticalRenderer", "verticalDecorationRenderer",
                    "rowHeaderTimePattern", "columnHeaderDatePattern", "timeSlotDuration", "rowHeaderGridSlotDuration", "rowHeaderLabelSlotDuration",
                    "rowHeaderLabelOffset", "rowHeaderFirstLabelOffset", "percentOverlap", "horizontalGap", "scrollBarRTLPosition", "itemToRendererKindFunc",
                    "layoutPriorityFunction", "formatItemTimeFunc", "textDir", "items", /*"subColumns",*/"minColumnWidth"]
            }
            ));


        this.columnView.on("columnHeaderClick", lang.hitch(this, "columnViewHeaderClick"));
        this.matrixView = dojoDeclare([MatrixView].concat(deviceBaseClasses))(lang.mixin(this.matrixView.params, { labelRenderer: MoreLabelRenderer, horizontalRenderer: MoreHorizontalRenderer }));
        this.matrixView._buildRowHeader = this.__matrixViewOverride_buildRowHeader;

        this.matrixView.on("rowHeaderClick", lang.hitch(this, "matrixViewRowHeaderClick"));


        this.monthColumnView = dojoDeclare([MonthColumnView].concat(deviceBaseClasses))({
            verticalRenderer: MoreLabelRenderer
        });

        this.monthColumnView.on("columnHeaderClick", lang.hitch(this, function (this: any, e: any) {
            this.set("dateInterval", "month");
            this.set("dateIntervalSteps", 1);
            this.set("date", e.date);
        }));

        //  Die größe der Stundenzellen so anpassen, dass immer 15 Stunden sichtbar sind solange der anzeigbare Bereich größer als 300px ist
        //
        aspect.after(this.columnView, "resize", lang.hitch(this, "resizeColumnViewHours"));

        return [this.columnView, this.matrixView, this.monthColumnView];
    }

    __matrixViewOverride_buildRowHeader(renderData: any, oldRenderData: any): void {

        console.log("__matrixViewOverride_buildRowHeader");

        // summary:
        //		Creates incrementally the HTML structure of the row header and configures its content.
        //
        // renderData:
        //		The render data to display.
        //
        // oldRenderData:
        //		The previously render data displayed, if any.
        // tags:
        //		private

        var rowHeaderTable = this.rowHeaderTable;

        if (!rowHeaderTable) {
            return;
        }

        var tbodies = query("tbody", rowHeaderTable);
        var tbody: any, tr: any, td: any;

        if (tbodies.length == 1) {
            tbody = tbodies[0];
        } else {
            tbody = domConstruct.create("tbody", null, rowHeaderTable);
        }

        var count = renderData.rowCount - (oldRenderData ? oldRenderData.rowCount : 0);

        // Build HTML structure
        if (count > 0) { // creation
            for (var i = 0; i < count; i++) {
                tr = domConstruct.create("tr", null, tbody);
                td = domConstruct.create("td", null, tr);

                var h = [];

                h.push(on(td, "click", lang.hitch(this, this._rowHeaderClick)));

                if ("ontouchstart" in document.documentElement) {
                    console.log("ontouchstart in document.documentElement");
                } else {
                    h.push(on(td, "mousedown", function (e: any) {
                        domClass.add(e.currentTarget, "Active");
                    }));

                    h.push(on(td, "mouseup", function (e: any) {
                        domClass.remove(e.currentTarget, "Active");
                    }));

                    h.push(on(td, "mouseover", function (e: any) {
                        domClass.add(e.currentTarget, "Hover");
                    }));

                    h.push(on(td, "mouseout", function (e: any) {
                        domClass.remove(e.currentTarget, "Hover");
                    }));
                }
                this._rowHeaderHandles.push(h);
            }
        } else {
            count = -count;
            // deletion of existing nodes
            for (var i = 0; i < count; i++) {
                tbody.removeChild(tbody.lastChild);
                var list = this._rowHeaderHandles.pop();
                while (list.length > 0) {
                    list.pop().remove();
                }
            }
        }

        // fill labels
        query("tr", rowHeaderTable).forEach(function (this: any, tr: any, i: any, arr: any) {

            if (arr.length <= renderData.dates.length) {
                domStyle.set(tr, "height", this._getRowHeight(i) + "px");

                var d = renderData.dates[i][0];

                var td: any = query("td", tr)[0];
                td.className = "";
                if (i == 0) {
                    domClass.add(td, "first-child");
                }
                if (i == this.renderData.rowCount - 1) {
                    domClass.add(td, "last-child");
                }

                this.styleRowHeaderCell(td, d, renderData);

                this._setText(td, this._formatRowHeaderLabel(d));
            }
        }, this);

    }

    matrixViewRowHeaderClick(e: any): void {
        this.set("dateInterval", "week");
        this.set("dateIntervalSteps", 1);
        this.set("date", e.date);
    }
    columnViewHeaderClick(e: any): void {
        this.set("dateInterval", "day");
        this.set("dateIntervalSteps", 1);
        this.set("date", e.date);

    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

}
moreCalendarMixin.prototype.declaredClass = 'moreCore.UI.Calendar.Mixins.moreCalendarMixin';

export default mdsWidget(moreCalendarMixin);
